import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_one-time-edit",
  "use": "svg_one-time-edit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg_one-time-edit\"><path d=\"m21.31 6.879-4.188-4.19a1.5 1.5 0 0 0-2.122 0L3.44 14.25A1.487 1.487 0 0 0 3 15.31v4.19A1.5 1.5 0 0 0 4.5 21h4.19a1.485 1.485 0 0 0 1.06-.44L21.31 9a1.5 1.5 0 0 0 0-2.121ZM8.69 19.5H4.5v-4.19l8.25-8.25 4.19 4.19-8.25 8.25ZM18 10.19 13.81 6l2.25-2.25 4.19 4.189-2.25 2.25Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol